import { useReducer, useCallback } from "react";

const initialState = {
  feedback: "silent",
};

function reducer(state, action) {
  const response = action.response;
  const type = action.type;

  switch (type) {
    case "silent":
    case "pending":
      return { feedback: type };

    case "ready":
      return { feedback: type, response, data: response.data };

    case "error":
      return { feedback: type, response, data: response.response?.data };

    case "setData":
      state.data = action.data;
      return { ...state };

    case "updateData":
      state.data = { ...state.data, ...action.data };
      return { ...state };

    default:
      console.error("Unknown dispatch type for useBackendAction reducer", action);
      throw new Error("Unknown dispatch type for useBackendAction reducer, contact administrator.");
  }
}

function useBackendAction(call) {
  const [state, dispatch] = useReducer(reducer, initialState);

  function fetch(data) {
    dispatch({ type: "pending" });

    return call(data)
      .then((result) => {
        dispatch({ type: "ready", response: result });
        return result;
      })
      .catch((error) => {
        console.error("Error when handling backend action", error);
        dispatch({ type: "error", response: error });
        throw error;
      });
  }

  const setData = useCallback((data) => {
    dispatch({ type: "setData", data });
  }, []);

  const updateData = useCallback((data) => {
    dispatch({ type: "updateData", data });
  }, []);

  return {
    fetch,
    updateData,
    setData,
    data: state.data,
    response: state.response,
    feedback: state.feedback,
  };
}

export default useBackendAction;
